import React, { useRef, useState } from "react";

import { ReactComponent as ArrowRight } from "../../../Assets/Images/ArrowRight.svg";
import "./Carousel.styles.css";

export const Carousel = ({ children }) => {
  const containerRef = useRef();
  const [scrollRightCount, setScrollRightCount] = useState(0);

  const btnpressprev = () => {
    let width = containerRef.current.clientWidth;
    containerRef.current.scrollLeft = containerRef.current.scrollLeft - width;
  };

  const btnpressnext = () => {
    let width = containerRef.current.clientWidth;
    containerRef.current.scrollLeft = containerRef.current.scrollLeft + width;

    setScrollRightCount(scrollRightCount + 1);
  };
  return (
    <div className="tiles-carousel">
      {scrollRightCount !== 0 && (
        <button onClick={() => btnpressprev()} className="pre-btn">
          <p>
            <ArrowRight
              role="img"
              type="img"
              aria-label="ArrowRight Icon"
              style={{
                transform: "rotate(180deg)",
              }}
            />
          </p>
        </button>
      )}
      <button onClick={() => btnpressnext()} className="next-btn">
        <p>
          <ArrowRight />
        </p>
      </button>

      <div ref={containerRef} className="tiles-container">
        {children}
      </div>
    </div>
  );
};
